import { joinNames } from '../../names';

/**
 * Deleting a shared item deletes it for everyone who holds it. The warning has to say so and
 * name them: from one person's tab the others are off screen, and an adviser who reads "delete"
 * as "delete mine" would take the others' records with it.
 */
export function deletionMessage(noun: string, ownerNames: string[]): string {
  return ownerNames.length > 1
    ? `This ${noun} is shared. Deleting it removes it for ${joinNames(ownerNames)}. This cannot be undone.`
    : `This permanently deletes this ${noun}. This cannot be undone.`;
}
